<template>
  <!-- 时钟  -->
  <div class="h-clock-view">
    <div class="h-clock-text" :style="{'font-size':fontSize+'px',color:color}">{{nowDate}}</div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      nowDate: '',
      timer: null
    }
  },
  props: {
    // value: {
    //   type: String,
    //   default: '选择用户'
    // },
    fontSize: {
      type: Number | String,
      default: 22
    },
    color: {
      type: String,
      default: '#3CBBFD'
    }
  },
  created () {

  },
  mounted () {
    this.timer = setInterval(() => {
      let date = new Date()
      this.nowDate = date.getFullYear().toString() + '-' + (date.getMonth() + 1).toString().padStart(2, '0') + '-' + date.getDate().toString().padStart(2, '0') + ' ' + date.getHours().toString().padStart(2, '0')
        + ':' + date.getMinutes().toString().padStart(2, '0') + ':' + date.getSeconds().toString().padStart(2, '0')
    }, 1000);
  },
  watch: {
  },
  computed: {
  },
  methods: {
  },
  destroyed () {
    clearInterval(this.timer)
    this.timer = null
  }
}
</script>
<style scoped lang="stylus">
.h-clock-view
  height 100%
  // width 180px
  display flex
  flex-direction row
  align-items center
  .h-clock-text
    font-family DIGITAL
    // font-family AbcClocks
    // font-weight 100
    font-weight 400
    letter-spacing 2px
</style>



// WEBPACK FOOTER //
// src/components/parts/h-clock.vue